module.exports = __webpack_public_path__ + "img/nexultra-O-200.acfe2f04.png";